export default {"src":"/_next/static/media/Zabbix.13431ffc.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};